<template>
  <section class="data-gauge">
    <DataCuesHeader :title="listData.cardTitle" :image="listData.cardImage"
      :subTitle="listData.cardSubTitle" :description="listData.cardDescription" />
    <div class="gauge-list">      
      <ul class="gauge-list__items">
        <li v-for="(item, i) in (listData.progressBars || [])" :key="i" class="gauge-row">
          <h2 v-if="item.title" class="gauge-row__title">{{ item.title }}</h2>
          <div class="gauge-row__bar-wrapper">
            <div class="gauge-row__bar" v-if="item.progressBarImage?.src">
              <img :src="item.progressBarImage?.src"
                :alt="(item.progressBarImage?.alt)" aria-hidden="true" />
            </div>
            <p v-if="item.statValue" class="gauge-row__value">{{ item.statValue }}</p>
          </div>
          <p v-if="item.description" class="gauge-row__desc">{{ item.description }}</p>
        </li>
      </ul>
    </div>
    <DataCuesFooter :sources="listData.sources" :links="listData.links" :footNoteText="listData.footNoteText"
      :learnMoreText="listData.learnMoreText" :learnMoreLink="listData.learnMoreLink" :isExternalLink="listData.isExternalLink"
      :learnMoreTaggingAttributes="listData.learnMoreTaggingAttributes" />
  </section>

</template>

<script>
import DataCuesHeader from './DataCuesHeader.vue'
import DataCuesFooter from './DataCuesFooter.vue'
export default {
  name: 'DataCuesGauge',
  props: {
    listData: { type: Object, required: true }
  },
  components: { DataCuesHeader, DataCuesFooter },
  computed: {
    normalizedSources() {
      const src = this.listData.sources || this.listData.footNoteText || [];
      const arr = Array.isArray(src) ? src : (src ? [src] : []);
      return arr.map(t => ({ text: t }));
    },
    normalizedLinks() {
      const links = this.listData.links || [];
      if (Array.isArray(links) && links.length) return links;
      if (this.listData.learnMoreText && this.listData.learnMoreLink) {
        return [{ text: this.listData.learnMoreText, url: this.listData.learnMoreLink, isExternal: !!this.listData.isExternalLink }];
      }
      return [];
    },
    hasFooter() {
      return this.normalizedSources.length > 0 || this.normalizedLinks.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped src="./DataCuesGauge.scss"></style>
